import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

type EyebrowProps = {
	children: React.ReactNode
	as?: 'span' | 'p' | 'div' | 'dt'
	className?: string
}

export function Eyebrow({ children, as: Component = 'span', className }: EyebrowProps) {
	return <Component className={cn('eyebrow', className)}>{children}</Component>
}
